<template>
    <div class="redpacketWrap">
        <!-- 头部 -->
        <div class="redpacket_header">
            <i @click="goBack" class="iconfont icon-left"></i>
            <ul class="title_box">
                <li v-for="val in titleArr" :class="content_index==val.id?'active':''" :key="val.id" @click="title_click(val)">{{val.title}}</li>
            </ul>
        </div>
        <div class="redpacket_content">
            <ul class="content_one" v-if="getList.length!==0">
                <li class="redpacket_list" v-for="val in getList" :key="val.id" @click="goUrl(val)">
                    <div class="list_left">
                        ￥<span>{{val.money}}</span>
                    </div>
                    <div class="list_right">
                        <div class="right_text">
                            <h3>抵用券</h3>
                            <p>{{val.name}}</p>
                            <p v-if="val.desc!==''">{{val.desc}}</p>
                        </div>
                        <div class="right_use" v-if="content_index==1">
                            <p v-if="val.ttl===0">{{val.expired_at}}</p>
                            <p v-else>倒计时：{{time}}</p>
                            <p class="use_text">去使用<i class="iconfont icon-jiantou"></i></p>
                        </div>
                        <div class="right_use" v-else-if="content_index==2">
                            <div class="used_text">已使用</div>
                        </div>
                        <div class="right_use" v-else>
                            <div class="used_text">已过期</div>
                        </div>
                    </div>
                </li>
            </ul>
            <div v-else class="noData">
                无数据
            </div>
        </div>
    </div>
</template>
<script>
import qs from "qs";
import { METHODS } from 'http';
import { setTimeout } from 'timers';
import { getLiBao } from "@/api/Redpacket"
export default {
    name: "redpacket",
    data(){
        return{
            titleArr:[{id:1,title:'未使用'},{id:2,title:'已使用'},{id:3,title:'已过期'}],
            content_index:1, //内容切换
            getList:[], //数据
            time:'', //倒计时
            ttl_time:'', //获取倒计时
        }
    },
    methods:{
        // 返回
        goBack(){
            location.href = 'http://m.lepu.cn/user/member'
        },
        // 标题切换
        title_click(val){
            this.content_index = val.id
            this.getData()
        },
        // 跳转路由
        goUrl(val){
            if(this.content_index === 1){
                var url = val.url
                location.href = url
            }else{
                return
            }
        },
        // 领取礼包
        getLibao(){
            getLiBao(qs.stringify({ids:[1,2,3,4]})).then(res=>{
                console.log(res)
            }).catch(err=>{
                console.log('err')
            })
        },
        // 我的礼券
        getData(){
            this.ajax.defaults.withCredentials = true;
            this.ajax.get('//api.lepu.cn/app/gift/my?status='+this.content_index).then(res=>{
                var res = res.data
                if(res.data.code === 1){
                    this.getList = res.data.data
                    this.getList.map((val,ind)=>{
                        if(val.ttl!==0){
                            this.ttl_time = this.getList[ind].ttl
                        }
                    })
                    if(this.ttl_time!==''){
                        this.formatSeconds(this.ttl_time)
                    }else{
                        return
                    }                    
                }else if(res.data.code === 999){
                    this.getList = []
                }else if(res.data.code === 10001){
                    location.href="http://m.lepu.cn/user/login"
                }
            })
        },
        // 秒转为时分秒
        formatSeconds(value) {
	        var secondTime = parseInt(value);// 秒
	        var minuteTime = 0;// 分
	        var hourTime = 0;// 小时
	        if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
	            minuteTime = parseInt(secondTime / 60);
	            secondTime = parseInt(secondTime % 60);
	            if(minuteTime > 60) {
	                hourTime = parseInt(minuteTime / 60);
	                minuteTime = parseInt(minuteTime % 60);
	            }
	        }
	        var result = "" + parseInt(secondTime) + "秒";
 
	        if(minuteTime >= 0) {
	        	result = "" + parseInt(minuteTime) + "分" + result;
	        }
	        if(hourTime >= 0) {
	        	result = "" + parseInt(hourTime) + "时" + result;
	        }
            this.time = result
            setTimeout(this.getData,1000)
	    }
    },
    created(){
        // this.getLibao()
        this.getData()
    }
}
</script>
<style lang="scss" scoped>
.redpacketWrap{
    width:100%;
    height: 100%;
    background:#f5f5f5;
    display: flex;
    flex-direction: column;
}

.redpacket_header{
    width: 100%;
    height: .98rem;
    display: flex;
    align-items: center;
    padding: 0 .32rem;
    box-sizing: border-box;
    background:#fff;

    i{
        padding-right: .32rem;
        box-sizing: border-box;
    }

    .title_box{
        flex:1;
        display: flex;
        padding-right: .32rem;
        box-sizing: border-box;
        justify-content: space-around;
        font-size: .34rem;
        color: #262626;
    }

    .active{
        color: #de4b4f;
    }
}

.redpacket_content{
    flex: 1;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    padding: 0 .3rem;
    box-sizing: border-box;

    ul{

        .redpacket_list{
            width: 100%;
            height: 1.6rem;
            background: url("//assets.lepucdn.cn/vue/images/packetBg.jpg");
            background-size: 100% 1.6rem;
            margin-top: .34rem;
            display: flex;
            align-items: center;

            .list_left{
                width: 1.66rem;
                text-align: center;
                font-size: .24rem;
                color: #ebb00c;
                font-weight: 800;

                span{
                    font-size: .5rem;
                }
            }

            .list_right{
                flex: 1;
                height: 100%;
                display: flex;
                padding-left: .3rem;
                padding-right: .3rem;
                box-sizing: border-box;

                .right_text{
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    text-align: left;
                    height: 100%;

                    h3{
                        font-size: .3rem;
                        margin-bottom: .04rem;
                        font-weight: 900;
                    }

                    p{
                        width: 100%;
                        font-size: .24rem;

                        &:nth-child(3){
                           color: #999;
                        }
                    }
                }

                .right_use{
                    width: 1.4rem;
                    text-align: right;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    position: relative;
                    height: 100%;

                    p{
                        &:nth-child(1){
                            -webkit-transform: scale(0.8);
                            position: absolute;
                            right: -.2rem;
                            top:.14rem;
                            width: 2.6rem;
                            color: #999;
                        }
                    }

                    .use_text{
                        font-size: .3rem;
                        color: #ebb00c;
                        height: .4rem;
                        display: flex;
                        align-items: center;

                        i{
                            font-size: .2rem;
                        }
                    }

                    .used_text{
                        font-size: .22rem;
                        color: #999;
                    }
                }
            }
        }
    }
}

.noData{
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 1rem;
}
</style>
